import App from "./App";
import PathProvider from "./libs/path/PathProvider";
import "./scss/index.scss"

import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import FManApi from "./fmanlibs/FManApi";
import SnackbarProvider from "./gui/Snackbar/SnackbarProvider";
import OverlayProvider from "./gui/Overlay/OverlayProvider";
import AuthProvider from "./gui/Login/AuthProvider";
import LoginProvider from "./gui/Login/LoginProvider";
import RootProvider from "./fmanlibs/RootProvider";

(async () => {
    const root = ReactDOM.createRoot(document.getElementById("root")!)

    root.render(
    <AuthProvider api={FManApi.i}>
        <PathProvider><SnackbarProvider><OverlayProvider><LoginProvider api={FManApi.i}>
            <RootProvider>
                <App/>  
            </RootProvider>
    </LoginProvider></OverlayProvider></SnackbarProvider></PathProvider>
    </AuthProvider>)

    serviceWorkerRegistration.register()
})()